import { Colors } from '@gripp/shared-ui';
import { Platform, StyleSheet, Text, TextInput, View } from 'react-native';
import { AlertInputs, ClearButtonProps } from './types';

type BaseNumberInputProps = {
  alertInputName: AlertInputs;
  getValues: any;
  setValue: any;
  placeholder: string;
  inputLabelValue?: string;
  clearButton: (inputType: ClearButtonProps) => JSX.Element;
};

export const BaseNumberInput = ({
  alertInputName,
  getValues,
  setValue,
  placeholder,
  inputLabelValue,
  clearButton,
}: BaseNumberInputProps) => {
  const ClearButton = clearButton;

  return inputLabelValue ? (
    <View style={styles.inputContainer}>
      <Text style={styles.inputLabel}>{inputLabelValue}</Text>
      <View style={{ flexDirection: 'row' }}>
        <TextInput
          value={getValues(alertInputName)}
          allowFontScaling={false}
          style={[styles.inputField]}
          placeholder={placeholder}
          placeholderTextColor={Colors.grayDisabled}
          keyboardType="numeric"
          onChangeText={(num) =>
            setValue(alertInputName, num, {
              shouldDirty: true,
              shouldValidate: true,
            })
          }
        />
        <ClearButton inputType={alertInputName} />
      </View>
    </View>
  ) : (
    <>
      <TextInput
        value={getValues(alertInputName)}
        allowFontScaling={false}
        style={styles.inputField}
        placeholder={placeholder}
        placeholderTextColor={Colors.grayDisabled}
        keyboardType="numeric"
        onChangeText={(num) =>
          setValue(alertInputName, num, {
            shouldDirty: true,
            shouldValidate: true,
          })
        }
      />
      <ClearButton inputType={alertInputName} />
    </>
  );
};

const styles = StyleSheet.create({
  inputContainer: {
    flex: 1,
    height: '100%',
    justifyContent: 'flex-start',
  },
  inputLabel: {
    fontSize: 11,
    fontWeight: '500',
    top: 5
  },
  inputField: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
    marginRight: 5,
    marginTop: 4,
    fontSize: 16,
    fontWeight: '400',
    borderWidth: 0,
    outlineWidth: 0,
    paddingVertical: 0,
    textAlignVertical: 'center',
    ...(Platform.OS === 'android' && {
      includeFontPadding: false,
    }),
  },
});
